import { useTheme } from '@material-ui/core/styles';
import { FiPackage } from 'react-icons/fi';
import { lighten } from 'polished';

import { Card, ICardsProps } from '../../../../components/Card';
import { useSettings } from '../../../../hooks/settings';

export const TotalOrdersCard = (
  props: Pick<ICardsProps, 'content' | 'percentage' | 'loading' | 'onClick'>
) => {
  const theme = useTheme();
  const { cardsLoading } = useSettings();

  return (
    <Card
      title="Total"
      icon={<FiPackage />}
      cardColor={lighten(0.325, theme.palette.info.main)}
      loading={cardsLoading}
      {...props}
    />
  );
};
